import React, { useContext, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { timesheetsRef } from "../firebase";
import EditIcon from "@mui/icons-material/Edit";
import { v4 as uuidv4 } from "uuid";
//import { useForm } from "react-hook-form";
import JobDescList from "./JobDescList";
import PrimaryForm from "./PrimaryForm";
import WarningIcon from "@mui/icons-material/Warning";

import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useJobDescriptions } from "../customHooks/useJobDescriptions";
import useTimesheet from "../customHooks/useTimesheet";
import { OperativesContext } from "../providers/OperativesProvider";
import Footer from "./Footer";
import { CombinedCosts } from "./CostCards";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import CloseIcon from "@mui/icons-material/Close";
import EngineeringIcon from "@mui/icons-material/Engineering";
import { useEditMode } from "../customHooks/useEditMode";
import { deleteJobDescriptions } from "../helperFunctions/dbFunctions";
import { AuthContext } from "../providers/AuthProvider";
import IdentifierBar from "./IdentifierBar";

import { initJobDescription, initPrimaryDetails } from "../helperFunctions/templateHelpers";
import { tooltips } from "../popData";
import { doc, setDoc } from "firebase/firestore";
import { updatePrimary } from "../helperFunctions/primaryWrites";
import { RatesContext } from "../providers/RatesProvider";
import { SlidersContext } from "../providers/SlidersProvider";
import FooterBtn from "./FooterBtn";
import { SettingsContext } from "../providers/SettingsProvider";

const Timesheet = () => {
  const history = useHistory();
  const params = useParams();
  const operatives = useContext(OperativesContext);
  const { user } = useContext(AuthContext);
  const rates = useContext(RatesContext);

  const containerRef = useRef(null);
  const { sliders, setSliderId, closeSlider } = useContext(SlidersContext);

  const [templateLoading, setTemplateLoading] = useState(false);

  const { inEditMode, toggleEditMode, isMarked, markItem, markedItems } = useEditMode();

  const timesheet = useTimesheet(timesheetsRef);
  const jobDescriptions = useJobDescriptions(params.uid, timesheetsRef);

  const { vat } = useContext(SettingsContext);
  let vatDiscrepancy =
    (vat === true && timesheet?.vatMode === false) ||
    (vat === false && timesheet?.vatMode === true) ||
    (vat === true && !timesheet?.vatMode);

  const showVat = timesheet?.vatMode;

  async function removeJobDescriptions() {
    await deleteJobDescriptions(markedItems, params.uid, timesheetsRef);
    toggleEditMode(containerRef.current);
  }

  const addJobDescription = async function (e) {
    const jobDescId = uuidv4();
    let jd = initJobDescription("BLANK", jobDescId, user?.uid, operatives);

    history.push(`/timesheet/jobDescription/${jobDescId}`, {
      timesheetId: params.uid,
      jobDescription: jd,
      primaryData: timesheet,
      type: "timesheet",
    });

    await setDoc(doc(timesheetsRef, `${params.uid}/jobDescriptions/${jobDescId}`), jd);
  };

  function pdfView() {
    history.push(`/timesheet/pdf`, { timesheet, jobDescriptions });
  }

  // function worksOrderView() {
  //   history.push(`/timesheet/worksOrderView`, { timesheet, jobDescriptions });
  // }

  function jobsheetView() {
    history.push(`/timesheet/jobsheetView`, { timesheet, jobDescriptions });
  }

  const handleSubcontract = (e) => {
    let value = !timesheet?.subcontracted;
    // console.log("handling sub contract", value);

    updatePrimary(doc(timesheetsRef, `${params.uid}`), { subcontracted: value });
  };

  const handleVatMode = (e) => {
    let value = !timesheet?.vatMode;

    updatePrimary(doc(timesheetsRef, `${params.uid}`), { vatMode: value });
  };

  const handleVatError = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  async function fillOutTemplate(templateType) {
    const jobDescId = uuidv4();
    let jd = initJobDescription(templateType, jobDescId, user?.uid, operatives, rates);
    let primaryDetails = initPrimaryDetails(templateType);

    setTemplateLoading(true);

    // Create new job description with new template details
    await setDoc(doc(timesheetsRef, `${params.uid}/jobDescriptions/${jobDescId}`), jd);

    // Update primary with new template details
    await updatePrimary(doc(timesheetsRef, `${params.uid}`), primaryDetails);

    setTemplateLoading(false);

    // window.scrollTo({
    //   top: 2500,
    //   behavior: "smooth",
    // });
  }

  let showBin = markedItems.length > 0 && inEditMode;

  return (
    <div ref={containerRef} className="primaryPage">
      <Footer title={timesheet.refNumber} back={sliders ? false : true} backlink="/">
        {vatDiscrepancy && (
          <FooterBtn title={tooltips.vatDiscrepancyError} cb={handleVatError}>
            <span className="vatDiscrepancyError">
              <WarningIcon style={{ fontSize: 28, color: "#ff3a3a" }} />
            </span>
          </FooterBtn>
        )}

        {sliders && (
          <>
            <FooterBtn title={tooltips.closeSlider} addClass="slider-control" cb={closeSlider}>
              <CloseIcon style={{ fontSize: 28 }} />
            </FooterBtn>

            <hr />
          </>
        )}

        <FooterBtn title={tooltips.vatMode} cb={handleVatMode}>
          <span
            className="vat-button"
            style={{ color: `${timesheet?.vatMode ? "#24a218" : "#5d5d5d"}` }}
          >
            vat
          </span>
        </FooterBtn>

        <FooterBtn title={tooltips.subcontracted} cb={handleSubcontract}>
          <EngineeringIcon
            style={{ fontSize: 28, color: `${timesheet.subcontracted ? "#24a218" : "#5d5d5d"}` }}
          />
        </FooterBtn>
        <hr />
        <FooterBtn title={tooltips.jobsheetView} cb={jobsheetView}>
          <AssignmentIcon style={{ fontSize: 28 }} />
        </FooterBtn>

        {/* <button
          title={tooltips.worksOrderView}
          className="adder"
          onClick={worksOrderView}
        >
          <HomeWorkIcon style={{ fontSize: 28 }} />
        </button> */}

        <FooterBtn title={tooltips.pdfView} cb={pdfView}>
          <PictureAsPdfIcon style={{ fontSize: 28 }} />
        </FooterBtn>

        <FooterBtn
          title={tooltips.edit}
          disable={vatDiscrepancy}
          cb={() => toggleEditMode(containerRef.current)}
          isActive={inEditMode}
        >
          <EditIcon style={{ fontSize: 28 }} />
        </FooterBtn>

        {showBin ? (
          <FooterBtn title={tooltips.binForever} cb={removeJobDescriptions}>
            <DeleteOutlinedIcon style={{ fontSize: 28 }} />
          </FooterBtn>
        ) : (
          <FooterBtn
            disable={vatDiscrepancy}
            title={tooltips.createJobDescription}
            cb={addJobDescription}
          >
            <PlaylistAddIcon style={{ fontSize: 34 }} />
          </FooterBtn>
        )}
      </Footer>

      {/* <div className="identifierBar">
        <button onClick={history.goBack}>Back</button>
        <p>TIMESHEET</p>
      </div> */}
      <IdentifierBar
        title="Timesheet"
        back={sliders ? false : true}
        backlink="/"
        templateLoading={templateLoading}
        callbacks={
          vatDiscrepancy
            ? []
            : [
                { name: "FA", cb: fillOutTemplate },
                { name: "EICR", cb: fillOutTemplate },
                { name: "FUSE", cb: fillOutTemplate },
                { name: "EICR_REMEDIALS", cb: fillOutTemplate },
              ]
        }
      />
      {/* <button onClick={pdfView}>pdf</button> */}

      <PrimaryForm data={timesheet} dbRef={timesheetsRef} primaryNumberText="Invoice" />

      {/* <button onClick={addJobDescription}>Add job description</button> */}

      <JobDescList
        inEditMode={inEditMode}
        toggleEditMode={toggleEditMode}
        isMarked={isMarked}
        markItem={markItem}
        markedItems={markedItems}
        jobDescriptions={jobDescriptions}
        dbRef={timesheetsRef}
        timesheetId={params.uid}
        primaryData={timesheet}
        vat={vat}
        vatDiscrepancy={vatDiscrepancy}
        type="timesheet"
      />

      <div className="section">
        <h3 className="heading">Total Costs</h3>
        <CombinedCosts timesheet={timesheet} jobDescriptions={jobDescriptions} vat={showVat} />
        {/* <CombinedCosts timesheet={timesheet} jobDescriptions={jobDescriptions} vat={vat} /> */}
      </div>
    </div>
  );
};

export default React.memo(Timesheet);
